function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.6234 5.39171C44.3223 2.25382 41.2763 0.260189 37.8267 0.0236093C36.0009 -0.101618 34.2184 0.275295 32.5429 1.07233C28.1141 3.17906 22.9634 3.17608 18.534 1.07074C16.8593 0.274768 15.0784 -0.101618 13.2537 0.0236093C5.13783 0.580196 -0.760541 10.8378 0.0797109 22.935C0.919609 35.0322 9.67261 44.2853 16.2955 43.8313C17.1746 43.7709 18.067 43.5359 18.9521 43.1453C23.143 41.2951 27.936 41.2937 32.1265 43.1446C33.012 43.5357 33.9051 43.7711 34.7847 43.8313C40.3169 44.2107 47.3321 37.8142 49.9831 28.647C44.5123 27.1815 40.389 22.148 40.389 16.3C40.389 11.7279 42.9092 7.65248 46.6234 5.39171Z",
  transform: "translate(0 13.717773)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 13.098C3.34209 12.9961 6.65361 11.6813 9.20441 9.14653C11.7552 6.61177 13.0783 3.32108 13.1808 0C9.83875 0.101868 6.52741 1.41667 3.97643 3.95143C1.42563 6.48619 0.102513 9.77688 0 13.098Z",
  transform: "translate(23.15332 0)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}));

var SvgIos = function SvgIos(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "68px",
    viewBox: "0 0 58 68",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ios.0f9333eb.svg";
export { ForwardRef as ReactComponent };